import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICurrency } from "../../../../../../components/currency/Currencies";

export interface IPaginationState {
  page: number;
  limit: number;
  count: number;
  lastVisitedPage: number;
  paginatedData: Record<
    number,
    {
      data?: any[];
      filters?: Record<string, string | number>;
      searchQuery?: string;
      totals?: any;
      currency?: ICurrency;
    }
  >;
  filters: Record<string, string | number>;
  searchQuery: string;
  totals: any;
  currency?: ICurrency;
}

const initialState: IPaginationState = {
  page: 1,
  limit: 10,
  count: 0,
  lastVisitedPage: 1,
  paginatedData: {},
  filters: {},
  searchQuery: "",
  totals: {},
  currency: {},
};

const PaginationSlice = createSlice({
  name: "CollectionOfficerGoalSettingsPagination",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    },
    setPaginatedData: (
      state,
      action: PayloadAction<{ page: number; data: any; totals: any }>,
    ) => {
      const { page, data, totals }: { page: number; data: any[]; totals: any } =
        action.payload;
      state.paginatedData[page] = {
        data,
        filters: state.filters,
        searchQuery: state.searchQuery,
        totals: totals,
        currency: state.currency,
      };
      state.totals = totals;
    },
    setLastVisitedPage: (state, action: PayloadAction<number>) => {
      state.lastVisitedPage = action.payload;
    },
    clearPaginatedData: (state) => {
      state.paginatedData = {};
    },
    setFilters: (
      state,
      action: PayloadAction<Record<string, string | number>>,
    ) => {
      state.filters = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setCurrency: (state, action: PayloadAction<ICurrency>) => {
      state.currency = action.payload;
    },
  },
});

export const {
  setPage,
  setLimit,
  setPaginatedData,
  setLastVisitedPage,
  setCount,
  clearPaginatedData,
  setFilters,
  setSearchQuery,
  setCurrency,
} = PaginationSlice.actions;

export const selectPagination = (state: {
  CollectionOfficerGoalSettingsPagination: IPaginationState;
}) => state.CollectionOfficerGoalSettingsPagination;

export default PaginationSlice.reducer;
